import type { BrandId } from "@ifa/utils";

import biblLogo from "./bibl/brand/logo.png";
import biblSolidLogo from "./bibl/brand/solidLogo.png";
import biblFavicon from "./bibl/brand/favicon.png";

import defaultLogo from "./default/brand/logo.png";
import defaultSolidLogo from "./default/brand/solidLogo.png";
import defaultFavicon from "./default/brand/favicon.png";

import zuuLogo from "./zuu/brand/logo.png";
import zuuSolidLogo from "./zuu/brand/solidLogo.png";
import zuuFavicon from "./zuu/brand/favicon.png";

export const brandAssets = {
  bibl: {
    logo: biblLogo,
    solidLogo: biblSolidLogo,
    favicon: biblFavicon,
  },
  default: {
    logo: defaultLogo,
    solidLogo: defaultSolidLogo,
    favicon: defaultFavicon,
  },
  zuu: {
    logo: zuuLogo,
    solidLogo: zuuSolidLogo,
    favicon: zuuFavicon,
  },
} as const;

export function getBrandAssets(brandId?: BrandId) {
  if (brandId && brandId in brandAssets) {
    return brandAssets[brandId];
  }
  return brandAssets.default;
}
